import {useEffect, useMemo, useState} from "react";
import {isEqual} from "lodash";
import {applyOrder} from "./helpers";

export const useFlowOrder = (baselineIds: number[]) => {
  const [override, setOverride] = useState<number[] | null>(null);
  const orderedIds = useMemo(() => applyOrder(baselineIds, override), [baselineIds, override]);
  const hasChanges = !isEqual(orderedIds, baselineIds);

  useEffect(() => {
    if (!hasChanges) return;
    const warnBeforeLeaving = (event: BeforeUnloadEvent) => event.preventDefault();
    window.addEventListener("beforeunload", warnBeforeLeaving);
    return () => window.removeEventListener("beforeunload", warnBeforeLeaving);
  }, [hasChanges]);

  return {orderedIds, hasChanges, reorder: setOverride, discard: () => setOverride(null)};
};
